import { z } from "zod";
import { RequestExecutor } from "../../../transport/request-executor";

export class OverridesEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  create(dsId: string, versionId: string, themeId: string, body: any) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${versionId}/themes/${themeId}/overrides`,
      z.any(),
      {
        method: "POST",
        body,
      }
    );
  }
}
